<template>

    <v-dialog v-model="show" persistent max-width="80%">
        <v-card>
            <v-card-title>
                <v-icon class="mr-2">mdi-information-outline</v-icon>
                <span>Telsasoft Wiki</span>
                <!-- <v-btn class="ml-4" icon><v-icon large>mdi-arrow-left-circle</v-icon></v-btn>
                <v-btn class="ml-1" icon><v-icon large>mdi-arrow-right-circle</v-icon></v-btn> -->
                <div class="flex-grow-1"></div>
                <v-btn color="#FF5252" icon @click="$store.commit('closeWikiHelp')"><v-icon large>mdi-close-circle</v-icon></v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <iframe id="wiki-help-iframe" :src="`${$store.state.wikiHelp.domain}${$store.state.wikiHelp.route}?accesskey=${$store.state.wikiHelp.accessKey}`"></iframe>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    name: 'WikiDialog',
    props: {
        value: Boolean,
    },
    data: () => ({
        hack: '',
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
    },

    mounted() {
    },
  
};
</script>

<style scoped>

    #wiki-help-iframe {
        height: calc(100vh - 198px);
        width: 100%;
    }

    .v-card__text {
        padding: 0px !important;
        border-radius: 0 !important;
    }

</style>

